import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
	esp: (
		`
		<h4 class="mb-3 bold text-center">Danko</h4>

		<div class="poem">
			<p class="poem-block mb-3">
				Pro ĉio dankas Vin mi malavare: <br/>
				Pro la sufer’ kaŝita de l’ anim’, <br/>
				Venen’ de l’ kiso kaj de larm’ amaro, <br/>
				Venĝ’ de fremdul’, amika kalumni’.
			</p>

			<p class="poem-block mb-3">
				Pro la anim’, dezerte pereinta, <br/>
				Pro ĉiu fals’ en tiu tera viv’. <br/>
				Kaj nun nur tion faru vi, Kreinto, <br/>
				Ke mi ne longe plu dankadu Vin.
			</p>
		</div>


		<h4 class="mt-5 mb-3 bold text-center">Anĝelo</h4>


		<div class="poem">
			<p class="poem-block mb-3">
				Kun kanto tenera tra nokta ĉiel’ <br/>
				Serene flugadis anĝel’. <br/>
				Kaj luno, kaj steloj, kaj blanka nubar’ <br/>
				Aŭskultis la kanton kun kar’.
			</p>

			<p class="poem-block mb-3">
				Li kantis pri viv’ en beata ĝarden’ <br/>
				En bela senpeka Eden’, <br/>
				Pri Dio eterna, kaj sonis ador’ <br/>
				En voĉ’ kun sincera fervor’.
			</p>

			<p class="poem-block mb-3">
				Li portis animon por tera ekzist’, <br/>
				Por vivo en larmoj kaj trist’; <br/>
				Sed restis memor’ en la juna anim’ <br/>
				Pri l’ kant’ de ĉiela sublim’.
			</p>

			<p class="poem-block mb-3">
				Ĝi longe suferis senvorte sur ter’, <br/>
				Strebante al stranga mister’, <br/>
				Kaj l’ kanton ĉielan, gardatan en kor’, <br/>
				Ne venkis enua viv-ĥor’. 
			</p>
		</div>
	`
	)
}

const itemName = {
	esp: 'Mihail Lermontov'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;